import getApolloClient from '../../app/apollo/getApolloClient';
import { gql } from '../../graphql/generated/gql';

const UPLOAD_POST_ATTACHMENT_MUTATION = gql(/** @complexity 2 */ `
  mutation uploadPostAttachment($file: Upload!) {
    attachment: uploadPostAttachment(file: $file) {
      url
    }
  }
`);

export default async function uploadPostAttachment(file: File) {
  const client = getApolloClient();
  if (client) {
    const { data } = await client.mutate({
      mutation: UPLOAD_POST_ATTACHMENT_MUTATION,
      variables: { file },
    });

    if (data) return data.attachment.url;
  }

  return null;
}
